import { useMutation } from "@tanstack/react-query";
import { verifyUserEmail } from "../../apis/user";

type VerifyEmailParams = {
  token: string;
  email: string;
};

export function useVerifyEmail() {
  const { mutate, data, error, status } = useMutation({
    mutationFn: ({ token, email }: VerifyEmailParams) => {
      return verifyUserEmail(token, email);
    },
  });

  return {
    verifyUserEmail: mutate,
    result: data,
    error,
    status,
    isLoading: status === "pending",
  };
}
